var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-reset-send"},[_c('PageHeader',{attrs:{"title":"Reset password"}}),_c('SendResetForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }